/**
 *
 * state状态
 * @typedef {Object} AppState
 * @description 应用本身使用的redux state
 * @property {boolean} serverFormVisible: 新建编辑社区弹窗
 */

import { WORKING_STATUS } from "@/views/AIEdit/consts";

const Worker = {
  state: {
    drawInfo: {}, // 绘图数据
    reDrawInfo: {}, // 改图数据
    freshWorkSaveRecord: false, // 是否主动刷新保存记录
    currentReDrawWorkID: '', // 最近一次的改图workID
    currentWorkImageItem: '', // 改图-小图列表当前选中的图片
    reDrawWorkStatus: '', // 改图工作状态
    reDrawWorkQueueInfo: {},// 改图排队信息
    initScaleNum: 0, // 缩放
    currentReDrawMode: 0, // 
    frontEndHasEdited: false, // 前端发生了新编辑动作(抠图等场景)
    saveRecordParams: {}, // 抠图记录保存参数
    currentHotWorkType: 0, // 当前热门作品类型
    workTime: 60, // 改图需要的预计时间-目前只有细节增强使用
  },
  reducers: {
    /**
     * @description 更新state
     * @param state: 当前state
     * @param payload: 更新state对象
     */
    updateState(state, payload) {
      return {
        ...state,
        ...payload,
      };
    },
  },
  effects: (dispatch) => ({
    updateDrawInfo(data) {
      this.updateState({
        drawInfo: data,
      });
    },
    updateReDrawInfo(data) {
      this.updateState({
        reDrawInfo: data,
      });
    },
    updateRefreshWorkSaveRecord(isReload) {
      this.updateState({
        freshWorkSaveRecord: isReload,
      });
    },
    updateCurrentReDrawWorkID(workID) {
      this.updateState({
        currentReDrawWorkID: workID,
      });
    },
    updateCurrentWorkImageItem(imageItem) {
      this.updateState({
        currentWorkImageItem: imageItem,
      });
    },
    updateReDrawWorkStatus(status) {
      this.updateState({
        reDrawWorkStatus: status,
      });
      if (status === WORKING_STATUS.START) {
        this.updateState({
          initScaleNum: 1,
        });
      } else if (status === WORKING_STATUS.DONE) {
        this.updateState({
          initScaleNum: 0,
        });
      }
    },
    updateReDrawWorkQueueInfo(data) {
      this.updateState({
        reDrawWorkQueueInfo: data,
      });
    },
    updateCurrentReDrawMode(mode) {
      this.updateState({
        currentReDrawMode: mode,
      });
    },
    updateFrontEndHasEdited(data) {
      this.updateState({
        frontEndHasEdited: data,
      });
    },
    updateSaveRecordParams(params) {
      this.updateState({
        saveRecordParams: params,
      });
    },
    updateCurrentHotWorkType(params) {
      this.updateState({
        currentHotWorkType: params,
      });
    },
    updateWorkTime(params) {
      this.updateState({
        workTime: params,
      });
    }
  }),
};

export default Worker;
